<template>
    <transition name="slide-fade">
        <div class="modal" :class="{'open' : open}" v-if="open">
            <div class="modal-content">
                <div class="bg-a-egg-f5ebdc w-full rounded-10 p-6 relative">
                    <div class="absolute top-3 right-3" @click="hide()">
                        <img class="cursor-pointer w-25px" src="../../../../../assets/icon/ic-close-brown.svg">
                    </div>
                    <div class="text-center text-14 text-a-brown-502314 mt-5 mb-9">
                        {{lbl.confirm_redeem.please_confirm_1}} {{FilterNumberFormat(getPointCampaign)}} {{lbl.confirm_redeem.please_confirm_2}}
                    </div>
                    <div class="w-48 m-auto">
                        <RedButton @click="clickOk()">{{lbl.confirm_redeem.confirm}}</RedButton>
                    </div>
                    <div class="text-center text-12 text-a-brown-9f8273 mt-3">
                        {{lbl.confirm_redeem.after_confirm_1}} {{lbl.confirm_redeem.after_confirm_2}} {{lbl.confirm_redeem.after_confirm_3}}
                    </div>
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open"></div>
    </transition>
</template>
<script>
import LocaleMixin from "@/mixin/LocaleMixin.js";
import RedButton from '@/components/Button/RedButton.vue';
// import WhiteButton from '@/components/Button/WhiteButton.vue';

export default {
    name: "ConfirmRedeemRewardModal",
    mixins: [LocaleMixin],
    components: {
        RedButton,
        // WhiteButton,
    },
    props: {
        controller: Object,
    },
    data: function() {
        return {
            campaign: null,
            open: false,

            busModal: null,
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    watch: {
        '$route.path': function() {
            if (this.open) {
                this.hide();
            }
        },
    },
    computed: {
        getPointCampaign: function () {
            if (this.campaign == null) {
                return 0;
            }
            return this.campaign.pointPerUnit;
        },
    },
    methods: {
        show: function (config) {
            this.campaign = config.campaign;

            document.body.classList.add('not-scroll');
            this.open = true;
        },
        hide: function() {
            document.body.classList.remove('not-scroll');
            this.open = false;
        },
        clickOk: function () {
            this.hide();
            this.controller.sendCallbackOk();
        },


    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/modal.scss";
    .modal {
        @extend %modal;
    }
</style>
